import styled from "styled-components";
import AutosizeInput from "react-input-autosize";

export const Budget = styled.h4`
  display: flex;
  position: relative;
  .tipp_info__tool-icon {
    top: -8px;
  }
`;

export const BudgetWarning = styled.div`
  position: absolute;
  top: -22px;
  left: 0;
  color: red;
  font-size: 12px;
  white-space: nowrap;
`;

export const BudgetInput = styled(AutosizeInput)`
  input {
    padding: 0 0 0 5px;
    margin: 0 2px 0 0;
    border: 1px solid transparent;
    background-color: transparent;
    transition: 0.2s all;
    border-radius: 6px;
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &:hover {
      background-color: #ced2d5;
    }
    &:focus {
      border: 1px solid black;
      background-color: white !important;
    }
  }
`;

export const BudgetMinMax = styled.div`
  display: inline-flex;
  margin-left: 15px;
  flex-direction: column;
  white-space: nowrap;
  p {
    margin: 0 !important;
    line-height: 1 !important;
  }
`;
